import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { applyEnvironmentBranding } from "@/lib/envBranding";

applyEnvironmentBranding();

// "ResizeObserver loop" is a benign browser notice (often fired by popovers on
// mobile); stop it before dev overlays / global handlers treat it as a crash.
const isResizeObserverNoise = (msg) => /ResizeObserver loop/i.test(msg || "");
window.addEventListener("error", (e) => {
  if (isResizeObserverNoise(e.message)) { e.stopImmediatePropagation(); e.preventDefault(); }
}, true);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
